import { render, staticRenderFns } from "./VoucherPayment.vue?vue&type=template&id=85b7e158"
import script from "./VoucherPayment.vue?vue&type=script&lang=js"
export * from "./VoucherPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports